import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import { AuthProvider, useAuth, homeForRole } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import InstallPrompt from "./components/InstallPrompt";

import Login from "./pages/Login";

import AdminDashboard from "./pages/AdminDashboard";
import AdminSessions from "./pages/AdminSessions";
import AdminSessionDetail from "./pages/AdminSessionDetail";
import AdminReports from "./pages/AdminReports";
import AdminUsers from "./pages/AdminUsers";
import AdminAudit from "./pages/AdminAudit";

import { CounterDashboard, CounterSession } from "./pages/Counter";
import { HeadCounterDashboard, HeadCounterSession } from "./pages/HeadCounter";
import AlleyHead from "./pages/AlleyHead";
import { WHAlleyDashboard, WHAlleySession } from "./pages/WHAlley";

function RoleHome() {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return <div className="p-10 text-zinc-500">Loading…</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={homeForRole(user.role)} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <InstallPrompt />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RoleHome />} />

          <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/sessions" element={<ProtectedRoute role="admin"><AdminSessions /></ProtectedRoute>} />
          <Route path="/admin/sessions/:id" element={<ProtectedRoute role="admin"><AdminSessionDetail /></ProtectedRoute>} />
          <Route path="/admin/reports" element={<ProtectedRoute role="admin"><AdminReports /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute role="admin"><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/audit" element={<ProtectedRoute role="admin"><AdminAudit /></ProtectedRoute>} />

          <Route path="/counter" element={<ProtectedRoute role="counter"><CounterDashboard /></ProtectedRoute>} />
          <Route path="/counter/sessions/:id" element={<ProtectedRoute role="counter"><CounterSession /></ProtectedRoute>} />

          <Route path="/head-counter" element={<ProtectedRoute role="head_counter"><HeadCounterDashboard /></ProtectedRoute>} />
          <Route path="/head-counter/sessions/:id" element={<ProtectedRoute role="head_counter"><HeadCounterSession /></ProtectedRoute>} />

          <Route path="/alley-head" element={<ProtectedRoute role="alley_head"><AlleyHead /></ProtectedRoute>} />
          <Route path="/alley-head/sessions/:id" element={<ProtectedRoute role="alley_head"><AlleyHead /></ProtectedRoute>} />

          <Route path="/wh-alley" element={<ProtectedRoute role="wh_alley"><WHAlleyDashboard /></ProtectedRoute>} />
          <Route path="/wh-alley/sessions/:id" element={<ProtectedRoute role="wh_alley"><WHAlleySession /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
